"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const toggle_gruppe_pure_1 = __importDefault(require("./toggle-gruppe-pure"));
const toggle_knapp_pure_1 = require("./toggle-knapp-pure");
class ToggleGruppe extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (e, index, customOnClick) => {
            if (typeof customOnClick === "function")
                customOnClick(e);
            const newActive = this.state.active.map((active, i, array) => {
                if (this.props.multiSelect) {
                    if (this.props.minstEn &&
                        array.filter(Boolean).length === 1 &&
                        array.indexOf(true) === index) {
                        return active;
                    }
                    return i === index ? !active : active;
                }
                if (this.props.minstEn) {
                    return i === index;
                }
                return i === index ? !active : false;
            });
            this.setState({
                active: newActive,
            });
            if (typeof this.props.onChange === "function") {
                this.props.onChange(e, this.props.defaultToggles.map((props, i) => (Object.assign(Object.assign({}, props), { pressed: newActive[i] }))));
            }
        };
        this.state = {
            active: this.props.defaultToggles.map(({ pressed }, index, array) => pressed ||
                (!!this.props.minstEn &&
                    index === 0 &&
                    array.every((toggle) => !toggle.pressed))),
        };
    }
    render() {
        const renderProps = (0, nav_frontend_js_utils_1.omit)(this.props, "children", "multiSelect", "toggles", "minstEn");
        const toggles = this.props.defaultToggles.map((toggle, i) => (Object.assign(Object.assign({}, toggle), { pressed: this.state.active[i], kompakt: this.props.kompakt, onClick: (e) => this.handleClick(e, i, toggle.onClick) })));
        return React.createElement(toggle_gruppe_pure_1.default, Object.assign({}, renderProps, { toggles: toggles }));
    }
}
ToggleGruppe.propTypes = {
    /**
     * Array av toggle knapper, se `toggle-knapp-pure.tsx`
     */
    defaultToggles: PT.arrayOf(toggle_knapp_pure_1.ToggleKnappPurePropsShape).isRequired,
    /**
     * Egendefinert klassenavn.
     */
    className: PT.string,
    /**
     * Hvis `true` vil det være mulig å velge flere knapper om gangen.
     */
    multiSelect: PT.bool,
    /**
     * Hvis 'true' reduseres høyre/venstre-padding på knappene betraktelig.
     */
    kompakt: PT.bool,
    /**
     * Custom onChange handler
     */
    onChange: PT.func,
    /**
     * Hvis 'true' så må minst 1 toggleknapp alltid være presset
     */
    minstEn: PT.bool,
};
exports.default = ToggleGruppe;
